import { STUDIO_GENDER_IMAGE_URLS } from '../constants/studioGenderAssets';

const loadedUrls = new Set();
const pendingUrls = new Set();

export const preloadImage = (url) => {
	if (!url || loadedUrls.has(url) || pendingUrls.has(url)) {
		return Promise.resolve();
	}

	pendingUrls.add(url);

	return new Promise((resolve) => {
		const img = new Image();
		img.decoding = 'async';

		const finish = () => {
			pendingUrls.delete(url);
			loadedUrls.add(url);
			resolve();
		};

		img.onload = finish;
		img.onerror = finish;
		img.src = url;
	});
};

export const preloadImages = (urls) => Promise.all(urls.map((url) => preloadImage(url)));

export const preloadStudioGenderAssets = () =>
	preloadImages(STUDIO_GENDER_IMAGE_URLS);
